import axios from 'utils/axios';

// eslint-disable-next-line import/prefer-default-export
export async function getMedHXSubmissionManagementList() {
    try {
        const response = await axios.get('/api/org-id/{orgId}/medhx-submission-management/list');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}
